import { connect } from 'react-redux'
import { VoiceCreateQuoteStepComponent } from './VoiceCreateQuoteStep'
import { getQuote } from '../Voices.actions'
import { IVoicesState } from '../Voices.reducer'

const stateToProps = ({ voices }: { voices: IVoicesState }) => ({
  price: voices.quote.price,
  loading: voices.quoteLoading,
})

export const dispatchToProps = {
  getQuote,
}

export const VoiceCreateQuoteStep = connect(
  stateToProps,
  dispatchToProps
)(VoiceCreateQuoteStepComponent)



// WEBPACK FOOTER //
// src/features/Voices/VoiceCreateQuoteStep/VoiceCreateQuoteStep.container.ts